import { RouterStore } from "mobx-react-router";

import AuthStore from "app/AuthStore";
import PageStore from "app/PageStore";
import LawyerStore from "contexts/lawyers/LawyerStore";
import ConsultationStore from "contexts/consultations/ConsultationStore";
import AdStore from "contexts/adCampaigns/AdStore";
import CommunityStore from "contexts/community/CommunityStore";
import AuthService from "./AuthService";

export default class RootStore {
  authService = new AuthService();
  routerStore = new RouterStore();
  authStore: AuthStore;
  pageStore: PageStore;
  lawyerStore: LawyerStore;
  consultationStore: ConsultationStore;
  adStore: AdStore;
  communityStore: CommunityStore;

  constructor() {
    this.authStore = new AuthStore(this, this.authService);
    this.pageStore = new PageStore(this);
    this.lawyerStore = new LawyerStore(this);
    this.consultationStore = new ConsultationStore(this);
    this.adStore = new AdStore(this);
    this.communityStore = new CommunityStore(this);
  }
}
